import { nextIteration } from "./_nextIteration.js";
export const any = (source, predicate) => {
    if (predicate) {
        return any2(source, predicate);
    }
    else {
        return any1(source);
    }
};
const any1 = async (source) => {
    const dataFunc = source.dataFunc;
    let values;
    switch (dataFunc.type) {
        case 1:
            values = dataFunc.generator();
            return values.length !== 0;
        case 0:
        case 2:
            values = await dataFunc.generator();
            return values.length !== 0;
    }
};
const any2 = async (source, predicate) => {
    const dataFunc = nextIteration(source, predicate);
    let values;
    switch (dataFunc.type) {
        case 0:
            values = await dataFunc.generator();
            return values.includes(true);
        case 1:
            values = await Promise.all(dataFunc.generator());
            return values.includes(true);
        case 2:
            values = await Promise.all(await dataFunc.generator());
            return values.includes(true);
    }
};
